import color from "@definitions/mui/color";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
    imageCloseBtn: {
      right: -20,
      top: -14,
      position: "absolute",
      borderRadius: "50%",
      width: "36px",
      height: "36px",
      padding: 10,
      background: color.white,
      cursor: "pointer",
      zIndex: 1,
    },
    closeIcon: {
      width: 15,
      height: 15,
      color: color.general.main,
    },
  }));

export default useStyles;
